var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0848 9.2874C12.366 15.4047 3.64834 15.5112 0.948874 9.43742C0.683709 8.84078 0.683709 8.15972 0.948874 7.56308C3.64834 1.48929 12.366 1.59578 15.0848 7.7131C15.3051 8.20853 15.3051 8.79198 15.0848 9.2874Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98233 10.9442C9.33171 10.9442 10.4256 9.85026 10.4256 8.50088C10.4256 7.15151 9.33171 6.05762 7.98233 6.05762C6.63295 6.05762 5.53906 7.15151 5.53906 8.50088C5.53906 9.85026 6.63295 10.9442 7.98233 10.9442Z",
    stroke: "#424242",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthVisibilityOn);
export default __webpack_public_path__ + "static/media/auth-visibility-on.887bcf292afa8b198843344c91e3770f.svg";
export { ForwardRef as ReactComponent };